(function () {
  function initSlider(el) {
    if (!el || el.swiper || typeof Swiper === 'undefined') return;

    var wrap = el.closest('.iw-customer-review__slider-wrap');
    var prevEl = wrap ? wrap.querySelector('.iw-customer-review__arrow--prev') : null;
    var nextEl = wrap ? wrap.querySelector('.iw-customer-review__arrow--next') : null;
    var navEl = wrap ? wrap.querySelector('.iw-customer-review__nav') : null;

    var swiper = new Swiper(el, {
      loop: false,
      speed: 450,
      spaceBetween: 20,
      slidesPerView: 1,
      watchOverflow: true,
      navigation:
        prevEl && nextEl
          ? {
              prevEl: prevEl,
              nextEl: nextEl,
            }
          : undefined,
      breakpoints: {
        575: {
          slidesPerView: 2.15,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3.25,
          spaceBetween: 20,
        },
      },
    });

    if (navEl && swiper.isLocked) {
      navEl.classList.add('is-hidden');
    }
  }

  function initSlidersInPanel(panel) {
    if (!panel) return;

    panel.querySelectorAll('[data-iw-customer-review-slider]').forEach(function (slider) {
      initSlider(slider);
      if (slider.swiper) {
        slider.swiper.update();
      }
    });
  }

  function initTabs(section) {
    var tabs = section.querySelectorAll('[data-iw-customer-review-tab]');
    if (tabs.length <= 1) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-iw-customer-review-tab');

        tabs.forEach(function (item) {
          var isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        section.querySelectorAll('[data-iw-customer-review-panel]').forEach(function (panel) {
          var isActive = panel.getAttribute('data-iw-customer-review-panel') === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;

          if (isActive) {
            initSlidersInPanel(panel);
          }
        });
      });
    });
  }

  function initSection(section) {
    if (!section) return;

    initTabs(section);

    var activePanel =
      section.querySelector('[data-iw-customer-review-panel].is-active') ||
      section.querySelector('[data-iw-customer-review-panel]:not([hidden])');

    initSlidersInPanel(activePanel);
  }

  function initAll() {
    document.querySelectorAll('[data-iw-customer-review]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-iw-customer-review]');
    if (!section && event.target.matches('[data-iw-customer-review]')) {
      section = event.target;
    }
    initSection(section);
  });
})();
